<template>
  <div id="Cdnrecords">
    <a href="https://cdnrecords.com/shop/mortor-burn-up-the-dead/" target="_blank"><img class="site-crest" alt="CDN Records logo" src="../assets/cdn-logo-crest.svg"></a>
  </div>
</template>

<script>
export default {
  name: 'Cdnrecords'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #Cdnrecords{
    margin-bottom: 12vh;
  }
  
  #Cdnrecords img{
    width: 20vw;
  }

</style>





// WEBPACK FOOTER //
// src/components/Cdnrecords.vue